import {
  QuestionSubmissionDetailsDto,
  RecommendationAttemptDto,
  RecommendationDto,
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { AssessmentGoalDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';

export enum ActivityProgressApplyScoreFilter {
  BEST_ATTEMPT = 'BEST_ATTEMPT',
  FIRST_ATTEMPT = 'FIRST_ATTEMPT',
  AVG_ALL_ATTEMPTS = 'AVG_ALL_ATTEMPTS',
  AVG_FIRST_TWO_ATTEMPTS = 'AVG_FIRST_TWO_ATTEMPTS',
}

export type ActivityLogTableData = {
  recommendation: RecommendationDto;
  goal: AssessmentGoalDto;
  recommendationAttempt: RecommendationAttemptDto;
  questionSubmissionDetail: QuestionSubmissionDetailsDto;
}

export enum RaasQuizMetricType {
  QUESTIONS_ATTEMPTED = 'QUESTIONS_ATTEMPTED',
  QUESTIONS_CORRECT = 'QUESTIONS_CORRECT',
  FIRST_ATTEMPT_SCORE = 'FIRST_ATTEMPT_SCORE',
  CURRENT_SCORE = 'CURRENT_SCORE',
  TOTAL_TIME_SPENT = 'TOTAL_TIME_SPENT',
}
